define('model/revision.model',['require','exports','module','fukit','datakit/util/url'],function(require, exports, module) {
  //prettier-ignore
  var Base = require('fukit').BaseModel,
      url  = require('datakit/util/url');

  var Revision = Base.extend(
    {
      radioRequests: {
        'models Revision': '@constructor',
      },

      urlRoot: '/api/v1/eform/revision',

      publish: function() {
        var model = this;
        return Promise.try(function() {
          return model.save().promise();
        })
          .then(function() {
            return model._publish().promise();
          })
         .catch(function(error) {
            console.error('An error occurred while publishing radioRequests:', error);
             throw error;
         })
         .thenReturn(model);
      },

      _publish: function() {
        return this.save(
          {},
          {
            url: url.template('/api/v1/eform/revision/publish/:id', this),
            type: 'POST',
          }
        );
      },

      revertTo: function(revertToId) {
        var model = new Base();
        return model.save(
          {},
          {
            url: url.template('/api/v1/eform/revision/revert/:id/:revertToId', { id: this.id, revertToId: revertToId }),
            type: 'POST',
          }
        );
      },

      revert: function() {
        var revisionCollection = new Revision.Collection();
        var filters = revisionCollection.filters;
        var model = this;

        filters.add({ field: 'publishedDate' }).isNull();

        filters.add({ field: 'template.id', value: this.get('template.id') });

        return revisionCollection
          .fetch()
          .promise()
          .then(function() {
            var unpublishedRevisionModel = revisionCollection.first();

            if (unpublishedRevisionModel) {
              return unpublishedRevisionModel.revertTo(model.id).promise();
            }
          })
          .catch(function(error) {
              console.error('An error occurred while fetching revisions:', error);
          });
      },
    },
    {}
  );
  module.exports = Revision;
});

